/** Workspace Orders automatic polling. Leaves v2 `ORDERS_POLLING_INTERVAL` unchanged. */
export const ATD_WORKSPACE_ORDERS_POLLING_INTERVAL = 10_000;

/** Ignore further manual Refresh clicks for this long after an accepted click. */
export const ATD_ORDERS_MANUAL_REFRESH_COOLDOWN_MS = 1_000;
